import React, { memo } from 'react'

import {
  Divider,
  Button,
  Icon,
  InfoOutlined,
  Toggle,
  Tooltip,
  Trash,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool, number, oneOfType } from 'prop-types'

import { iconSize, PRIVATE_MODE_TOOLTIP_MESSAGE } from 'Pods/ThreeDStudio/constants'
import SubscribersOnlyHover from 'Pods/ThreeDStudio/Shared/SubscribersOnlyHover/SubscribersOnlyHover'

import { NOOP } from 'Utils/stableDefaults'

const deleteIcon = <Icon svgComponent={Trash} color="dark" size={iconSize} />
const infoIconSize = { height: '14px', width: '14px' }

const formatCreatedAt = (isoString) =>
  new Date(isoString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

function ModelCardContent({
  title = '',
  createdAt,
  onDelete: handleDelete = NOOP,
  isDeleting = false,
  runId = undefined,
  isPrivate = false,
  canTogglePrivacy = false,
  onTogglePrivacy: handleTogglePrivacy = NOOP,
  isPrivacyUpdating = false,
}) {
  const privacyRow = (
    <div className="model-card__privacy">
      <div className="model-card__privacy-label">
        {/* The control is the input rendered inside the Triangle UI Toggle with this id */}
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor={`make-private-${runId}`} className="cgt-body-base-semibold">
          Make Private
        </label>
        <Tooltip
          id={`make-private-info-${runId}`}
          content={PRIVATE_MODE_TOOLTIP_MESSAGE}
          tooltipClassName="model-settings__tooltip"
        >
          <Icon svgComponent={InfoOutlined} color="darker" size={infoIconSize} notSpaced />
        </Tooltip>
      </div>
      <Toggle
        id={`make-private-${runId}`}
        className="model-card__privacy-toggle"
        size="small"
        isChecked={isPrivate}
        onChange={handleTogglePrivacy}
        disabled={!canTogglePrivacy || isPrivacyUpdating}
      />
    </div>
  )

  return (
    <div className="model-card__content">
      <div className="model-card__content-header">
        {title && <span className="cgt-body-base-semibold">{title}</span>}
        <span className="model-card__content-created-at cgt-caption">
          Created: {formatCreatedAt(createdAt)}
        </span>
      </div>
      <Divider />
      <Button
        type="ghost"
        variant="with-icon"
        icon={deleteIcon}
        size="small"
        customClass="model-card__content-button"
        onClick={handleDelete}
        disabled={isDeleting}
      >
        Delete
      </Button>
      <Divider />
      {canTogglePrivacy
        ? privacyRow
        : (
          <SubscribersOnlyHover
            id={`make-private-upsell-${runId}`}
            placement="right"
            alignBottom
            containerClassName="model-card__privacy-hover"
          >
            {privacyRow}
          </SubscribersOnlyHover>
        )}
    </div>
  )
}

ModelCardContent.propTypes = {
  title: string,
  createdAt: string.isRequired,
  onDelete: func,
  isDeleting: bool,
  runId: oneOfType([string, number]),
  isPrivate: bool,
  canTogglePrivacy: bool,
  onTogglePrivacy: func,
  isPrivacyUpdating: bool,
}

export default memo(ModelCardContent)
